import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

export default class extends Controller {
  static targets = [ "circleBtn" ]

  initialize() {
    setTimeout(()=>{
      this.setVariables()
    },1000)

    if(!this.cardsEls){
      return false
    }
    this.setupTimelines()
    this.setState()
  }


  setVariables(){
    this.cardsContainerEl = this.element.querySelector('.cards-container')
    this.cardsEls = this.cardsContainerEl.querySelectorAll('.card')
    this.cardWidth = this.cardsEls[0].getBoundingClientRect().width
    if(this.cardsEls){
      this.cardsTotal = this.cardsEls.length - 1
    }
    this.scrollIndex = 0
    this.scrollMax = this.cardsContainerEl.querySelectorAll('.card').length - 1
  }

  setupTimelines(){
    console.log('yoyoyo')

    this.circleBtnTargets.forEach((target)=>{
      const svgs = target.querySelectorAll('svg'),
      arrowSvg = target.querySelectorAll('svg')[0]

      const hoverTL = gsap.timeline({
        paused: true
      })
      .to(arrowSvg,{
        xPercent:200,
        duration:.25,
        autoAlpha:0
      },'start')
      .set(arrowSvg,{
        xPercent:-200,
        duration:.25,
        autoAlpha:1
      })
      .to(arrowSvg,{
        xPercent:0,
        duration:.25
      })

      target.addEventListener("mouseenter", ()=>{
        if(!target.classList.contains('disabled')){
          if (!hoverTL.isActive()) {
            hoverTL.progress(0).play()
          }
        }
      });
      target.addEventListener("click", ()=>{
        if(!target.classList.contains('disabled')){
          if (!hoverTL.isActive()) {
            hoverTL.progress(0).play()
          }
        }
      });
    })
  }

  scrollPrev(event){
    event.preventDefault()
    if(!event.target.closest('a').classList.contains('disabled')){
      this.scrollIndex = this.scrollIndex - 1
      this.scroll()
    }
  }
  
  scrollNext(event){
    event.preventDefault()
    if(this.cardsContainerEl.scrollLeft + (window.innerWidth - this.cardWidth) < (this.cardsTotal * this.cardWidth)) {
      this.scrollIndex++
    }
    this.scroll()
  }

  playLeave(event){
    // console.log(event)
  }

  setState(){
    const disabledClass = 'disabled'
    if(this.cardsContainerEl.scrollLeft == 0){
      this.circleBtnTargets[0].classList.add(disabledClass)
    }else{
      this.circleBtnTargets[0].classList.remove(disabledClass)
    }
    if(this.cardsContainerEl.scrollLeft + (window.innerWidth - this.cardWidth) < (this.cardsTotal * this.cardWidth)) {
      this.circleBtnTargets[1].classList.remove(disabledClass)
    }else{
      this.circleBtnTargets[1].classList.add(disabledClass)
    }
  }

  scroll(){
    console.log(this.cardWidth, this.scrollIndex)
    gsap.to(this.cardsContainerEl, {
      duration: .25,
      scrollTo: {
        x: this.cardWidth * this.scrollIndex,
      },
      onComplete:()=>{
        this.setState()
      }
    })
  }
}